import { render } from "./NDropdownItem.vue?vue&type=template&id=163dc1c2&ts=true"
import script from "./NDropdownItem.vue?vue&type=script&lang=ts"
export * from "./NDropdownItem.vue?vue&type=script&lang=ts"

import "./NDropdownItem.vue?vue&type=style&index=0&id=163dc1c2&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__